import Home from './home'
import auth from './auth'

/**
 * Accounts UI routes
 */
export default [
  Home,
  ...auth
]
